import React from 'react';
import { Grid } from '@material-ui/core';
import { StateUser } from '../../store/modules/users/types';
import { FormInformativePromotionCodeInput, Spinner } from '../../components';
import useStyles from './styles';
import CancelPlanButton from './buttons/CancelPlanButton';
import ChangePlanButton from './buttons/ChangePlanButton';
import RemainingCreditsTip from './CreditHistory/RemainingCreditsTip';
import PromotionCodeInput from '../../components/form-promotion-code-input/PromotionCodeInput';

type Props = {
  user: StateUser;
};

const BillingPage = ({ user }: Props) => {
  const classes = useStyles();
  const productTitle = user?.data?.ref.active_subscription?.product?.title || 'No subscription';
  const canUpgrade = user?.data?.ref.active_subscription?.can_upgrade || false;
  const canCancel = user?.data?.ref.active_subscription?.can_cancel || false;
  const promoCode = user?.data?.ref.active_subscription?.promotion_code || null;

  return (
    <Grid>
      {!user?.loading ? (
        <>
          <Grid item xs={12} className={classes.title}>
            Plan
          </Grid>
          <Grid item xs={12} className={classes.subTitle}>
            {productTitle}
          </Grid>
          {
            (canUpgrade || canCancel) && (
              <Grid item xs={12} className={classes.controlPanel}>
                <ChangePlanButton user={user.data} />
                <CancelPlanButton user={user.data} />
              </Grid>
            )
          }
          <Grid item xs={12}>
            {promoCode && (
              <FormInformativePromotionCodeInput
                label="Promo Code"
                promotionCode={promoCode}
              />
            )}
            {!promoCode && user?.data && <PromotionCodeInput user={user.data}/>}
          </Grid>
          <div className={classes.remainingCreditsWrapper}>
            <RemainingCreditsTip user={user.data} withNavigator />
          </div>

        </>
      ) : <Spinner />}
    </Grid>
  );
};

export default BillingPage;
